import type { BaslerIconRuntime } from '~/utils/icons/iconRuntime';
import { BASLER_ICON_RUNTIME } from '~/utils/icons/iconRuntime';

export default defineNuxtPlugin({
  name: 'iconRuntime',
  setup(nuxtApp) {
    const delta = useState<Record<string, string>>(
      'baslerIconRuntimeDelta',
      () => ({})
    );
    const extra = reactive<Record<string, string>>({});
    const pending = new Set<string>();
    const missed = new Set<string>();
    let queued: string[] = [];
    let flush: ReturnType<typeof setTimeout> | undefined;

    const runtime: BaslerIconRuntime = {
      resolve(name) {
        return extra[name] ?? delta.value[name];
      },
      track(name, svg) {
        extra[name] = svg;
      },
      request(names) {
        for (const name of names) {
          if (
            extra[name] ||
            delta.value[name] ||
            pending.has(name) ||
            missed.has(name)
          ) {
            continue;
          }
          pending.add(name);
          queued.push(name);
        }
        if (flush || queued.length === 0) {
          return;
        }
        flush = setTimeout(() => {
          const batch = queued;
          queued = [];
          flush = undefined;
          void $fetch<Record<string, string>>('/api/icons', {
            query: { names: batch.join(',') }
          })
            .then((result) => {
              for (const name of batch) {
                pending.delete(name);
                const svg = result[name];
                if (svg) {
                  extra[name] = svg;
                } else {
                  missed.add(name);
                }
              }
            })
            .catch(() => {
              for (const name of batch) {
                pending.delete(name);
                missed.add(name);
              }
            });
        }, 0);
      }
    };
    nuxtApp.vueApp.provide(BASLER_ICON_RUNTIME, runtime);
  }
});
